<dx-popup
  [showTitle]="true"
  [title]="title"
  [showCloseButton]="false"
  [dragEnabled]="true"
  [resizeEnabled]="true"
  [shading]="false"
  [hideOnOutsideClick]="false"
  [position]="position"
  [width]="width"
  [height]="isCollapsedSig() ? 52 : 'auto'"
  [minWidth]="minWidth"
  [wrapperAttr]="wrapperAttr"
  [visible]="visible"
>
  <dxi-popup-toolbar-item
    widget="dxButton"
    location="after"
    [options]="{
      stylingMode: 'text',
      icon: isCollapsedSig() ? 'chevrondown' : 'chevronup',
      hint: isCollapsedSig() ? 'Expand settings' : 'Collapse settings',
      onClick: toggleCollapse,
    }"
  ></dxi-popup-toolbar-item>

  <!-- Content is dropped, not hidden, while collapsed: the panel shrinks to its
       title bar, so leaving a form mounted underneath would keep its height. -->
  <div *dxTemplate="let data of 'content'">
    @if (!isCollapsedSig()) {
      <ng-content></ng-content>
    }
  </div>
</dx-popup>
